export default 'sharealt';
